import { z } from 'zod';
import { ApiMethod } from '../types/api.types';
import { languageAndCountryCodeSchema } from '../types/locale.types';
import { localeParamsSchema } from '../types/payloads/locale.payload';

export const API_LOCALE_LANGUAGES_AND_COUNTRY_CODES = {
    LIST: {
        method: ApiMethod.GET,
        path: '/locales/:locale/languages-and-country-codes',
        handlerMethod: 'getLanguagesAndCountryCodes' as 'getLanguagesAndCountryCodes',
        zod: {
            params: localeParamsSchema
        },
        responses: {
            200: {
                description: 'List of languages and country codes',
                schema: z.array(languageAndCountryCodeSchema)
            }
        }
    }
};
